// extracted by mini-css-extract-plugin
export default {"navbar":"style_navbar__XUAbS","btn2":"style_btn2__qqNE7"};